import React from 'react';
import { motion } from 'framer-motion';
import { Share2Icon, BookOpenIcon, UsersIcon, BarChart3Icon, ShieldCheckIcon, CalendarClockIcon } from 'lucide-react';
import { SimpleDivider } from './Dividers';
const features = [{
  icon: <Share2Icon className="w-6 h-6" data-id="element-34" />,
  title: 'Cross-Realm Distribution',
  description: 'Simultaneous syndication across web, mobile, podcast, and streaming platforms from a single interface.'
}, {
  icon: <BookOpenIcon className="w-6 h-6" data-id="element-35" />,
  title: 'Lore-Matched Advertising',
  description: 'Contextual ad placement that respects narrative immersion, ensuring promotions feel like part of the world.'
}, {
  icon: <UsersIcon className="w-6 h-6" data-id="element-36" />,
  title: 'Guild Partnerships',
  description: 'Exclusive publisher coalitions granting access to premium campaign tiers previously reserved for major studios.'
}, {
  icon: <BarChart3Icon className="w-6 h-6" data-id="element-37" />,
  title: 'Tome Analytics',
  description: 'Real-time performance tracking with fantasy-audience benchmarks to measure your true impact.'
}, {
  icon: <ShieldCheckIcon className="w-6 h-6" data-id="element-38" />,
  title: 'Sigil Authentication',
  description: 'Ironclad content verification and rights management across the entire network to protect your intellectual property.'
}, {
  icon: <CalendarClockIcon className="w-6 h-6" data-id="element-39" />,
  title: 'Seasonal Campaigns',
  description: 'Themed syndication events tied to major fantasy releases, conventions, and cultural moments.'
}];
export const Features = () => {
  return <section className="py-24 bg-parchment-100 text-burgundy-950 relative texture-overlay" data-id="element-40">
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-41">
        <div className="text-center mb-16" data-id="element-42">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-display text-4xl md:text-5xl text-burgundy-900 mb-4" data-id="element-43">
            Arsenal of the Chronicler
          </motion.h2>
          <SimpleDivider className="my-6" data-id="element-44" />
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-burgundy-800 max-w-2xl mx-auto font-medium" data-id="element-45">
            Equip yourself with the finest tools forged for the modern fantasy
            publisher.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-46">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-parchment-50 border border-burgundy-200 p-8 relative group hover:shadow-xl transition-all duration-300" data-id="element-47">
              {/* Ornate corner accents */}
              <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-gold-600" data-id="element-48"></div>
              <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-gold-600" data-id="element-49"></div>
              <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-gold-600" data-id="element-50"></div>
              <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-gold-600" data-id="element-51"></div>

              <div className="text-gold-600 mb-6 group-hover:text-burgundy-700 transition-colors duration-300" data-id="element-52">
                {feature.icon}
              </div>
              <h3 className="font-heading text-xl font-bold text-burgundy-900 mb-3" data-id="element-53">
                {feature.title}
              </h3>
              <p className="text-burgundy-800 leading-relaxed" data-id="element-54">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};